import React, { useEffect, useState } from "react";
import FxAppBar from "../components/FxAppBar";
import {
  FxImageBoard,
  FxImageBoardConfig,
  FxImageBoardContainer,
  FxImageBoardContainerConfig,
} from "../components/FxImageBoard";
import { FxIconButton, FxIconButtonConfig } from "../components/FxIconButton";
import { FxTextBox, FxTextBoxConfig } from "../components/FxTextBox";
import { FxContentBox } from "../components/FxContentBox";
import { FxMenuList } from "../components/FxMenuList";
import { FxOpButton, FxOpButtonConfig } from "../components/FxOpButton";
import { FxTPDataGrid } from "../components/FxTPDataGrid";
import { FxMoListDash, FxMoListConfig } from "../components/FxMoList";

import {
  FxMap,
  FxMapContainer,
  FxMapContainerConfig,
} from "../components/map/FxMap";
import {
  FxRtGuageChart,
  FxRtGuageChartConfig,
} from "../components/charts/FxRtGuageChart";
import {
  FxLineChart,
  FxLineChartConfig,
} from "../components/charts/FxLineChart";
import { FxPieChart, FxPieChartConfig } from "../components/charts/FxPieChart";
import {
  FxLineZoomChart,
  FxLineZoomChartConfig,
} from "../components/charts/FxLineZoomChart";
import { FxFlowGojs } from "../components/Gadgets/charts/FxFlowGojs";

export class FxUiData {
  static compMap = new Map();

  static initBaseComp() {
    FxUiData.addComp("FxAppBar", FxAppBar);
    FxUiData.addComp("FxOpButton", FxOpButton, FxOpButtonConfig);
    FxUiData.addComp("FxRtGuageChart", FxRtGuageChart, FxRtGuageChartConfig);
    FxUiData.addComp("FxLineChart", FxLineChart, FxLineChartConfig);
    FxUiData.addComp("FxPieChart", FxPieChart, FxPieChartConfig);
    FxUiData.addComp("FxLineZoomChart", FxLineZoomChart, FxLineZoomChartConfig);
    FxUiData.addComp("FxImageBoard", FxImageBoard);
    FxUiData.addComp("FxContainerBox", FxImageBoardContainer);
    FxUiData.addComp("FxIconButton", FxIconButton, FxIconButtonConfig);
    // FxUiData.addComp("FxMap", FxMapContainer, FxMapContainerConfig);
    FxUiData.addComp("FxMap", FxMap);
    FxUiData.addComp("FxContentBox", FxContentBox);
    FxUiData.addComp("FxSensorBox", FxTPDataGrid);
    FxUiData.addComp("FxMenuList", FxMenuList);
    FxUiData.addComp("FxTextBox", FxTextBox, FxTextBoxConfig);
    FxUiData.addComp("FxMoList", FxMoListDash, FxMoListConfig);
    // FxCompData.addComp("FxIconValuePanel", FxIconValuePanel);
    // FxCompData.addComp("FxCalendar", FxCalendar);
    FxUiData.addComp("FxFlowGojs", FxFlowGojs);
  }

  /**
   *
   * @param {string} opId 운영ID
   * @param {JSX} resource 해당 화면
   * @param {*} config 환경설정이 있으면 해당 환경설정 화면
   */
  static addComp(opId, resource, config) {
    FxUiData.compMap.set(opId, { resource: resource, config: config });
  }

  /**
   * 기능ID에 해당되는 화면이 존재하면 알려준다.
   * @param {string} opId 기능 ID
   * @returns
   */
  static getCompResource(opId) {
    const ret = FxUiData.compMap.get(opId);
    return ret ? ret : null;
  }

  /**
   * 기능ID 또는 컴포넌트 종류의 화면을 제공한다.
   * @param {string} name 기능ID
   * @param {string} uiCmptName 컴포넌트 종류
   * @param {object} props 이 내용을 호출하는 화면에 그래도 넘긴다.
   * @returns
   */
  static makeResource(props) {
    console.log("*** FxCompData *** makeResource ", props);
    let TagName = null;
    let name = props.name ? props.name : props.uiCmptName;

    if (props.name) {
      TagName = FxUiData.getCompResource(props.name);
    }
    if (TagName === null && props.uiCmptName) {
      TagName = FxUiData.getCompResource(props.uiCmptName);
    }

    if (TagName === null) {
      return <div>{name} Not Found</div>;
    }

    return React.createElement(TagName.resource, props, null);
  }

  static getConfig(name, fxUiGrp, fxUiGrpItem) {
    // console.log("*** FxCompData *** makeResourceConfig " + name);

    const TagName = FxUiData.getCompResource(name);

    if (TagName === null || TagName.config === undefined) {
      return null;
    }

    return TagName.config(fxUiGrp, fxUiGrpItem);
  }
}
